import { render } from "./EditarResumenEmpresaView.vue?vue&type=template&id=22cdc992&ts=true"
import script from "./EditarResumenEmpresaView.vue?vue&type=script&lang=ts"
export * from "./EditarResumenEmpresaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__